<ng-container *ngIf="invoice; else loadingTemplate">
  <div style="width: 100%;margin-bottom: 8px;" fxLayout="column" fxLayoutAlign="start start">

    <!-- Tital / Action Row -->
    <div style="width: 100%; margin-bottom: 8px;" fxLayout="row" fxLayoutAlign="start start">
      <mat-card style="width: 100%;">
        <mat-card-content>
          <div style="width: 100%;" fxLayout="row" fxLayoutAlign="space-between center">
            <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 16px;">
              <div *ngIf="invoice.isExternalInvoice">
                <img style="height: 32px;" src="/assets/images/Window_World_Logo.jpg" />
              </div>
              <div class="page-title">{{invoice.title}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
              <button *ngIf="invoice.canRefundInvoice" mat-raised-button color="primary" (click)="refundCredit()">Refund
                Invoice</button>
              <button *ngIf="invoice.canRefundInvoice" mat-raised-button color="primary" (click)="transferCredit()">Transfer to Deposit</button>
              <button *ngIf="invoice.canRefundInvoice" mat-raised-button color="primary"
                (click)="requestEftRefund()">Request EFT Refund</button>
              <button *ngIf="invoice.canPayInvoice" mat-raised-button color="primary" (click)="payInvoice()">Pay
                Invoice</button>
              <button *ngIf="invoice.canPayInvoiceFromDeposit" mat-raised-button color="primary"
                (click)="payInvoiceFromDeposit()">Pay
                Invoice from Deposit</button>
              <button mat-raised-button color="primary" (click)="refresh()">Reload</button>
              <!--
              <button *ngIf="invoice.canCreateNewDraft" mat-raised-button color="primary"
                (click)="createNewDraftVersion()">Create New Version in Draft</button>
              <button *ngIf="invoice.canCopyToNewDraft" mat-raised-button color="primary"
                (click)="copyLinesToNewDraft()">Copy Lines to New Draft Order</button>
              <button *ngIf="invoice.canCreateSysproOrder" mat-raised-button color="primary"
                (click)="createSysproOrder()">Create SYSPRO Order</button>
              <button *ngIf="invoice.canCancelOrder" mat-raised-button color="warn"
                (click)="cancelOrderDialog()">Cancel</button> -->
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Header Cards Row -->
    <div style="width: 100%;" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
      <!-- General Details -->
      <mat-card fxFlex="25%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>General Details</div>
              <div>
                <!-- <button
                      *ngIf="invoice.canChangeSalesperson || invoice.canUseCashCustomer || invoice.canSearchExsistingCustomer || invoice.canCreateNewCustomer || invoice.canEditSysproCustomer"
                      mat-icon-button [matMenuTriggerFor]="menuGeneral">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuGeneral="matMenu">
                      <button *ngIf="invoice.canChangeSalesperson" mat-menu-item (click)="editSalesPersonDetails()">
                        <mat-icon>support_agent</mat-icon>
                        <span>Change Salesperson</span>
                      </button>
                      <button *ngIf="invoice.canUseCashCustomer" (click)="useCashCustomer()" mat-menu-item>
                        <mat-icon>attach_money</mat-icon>
                        <span>Use Cash Customer</span>
                      </button>
                      <button *ngIf="invoice.canSearchExsistingCustomer" (click)="searchCustomer()" mat-menu-item>
                        <mat-icon>search</mat-icon>
                        <span>Search Existing Customer</span>
                      </button>
                      <button *ngIf="invoice.canCreateNewCustomer" (click)="createSysproCustomer()" mat-menu-item>
                        <mat-icon>person_add</mat-icon>
                        <span>Create SYSPRO Customer</span>
                      </button>
                      <button *ngIf="invoice.canEditSysproCustomer" (click)="editSysproCustomer()" mat-menu-item>
                        <mat-icon>manage_accounts</mat-icon>
                        <span>Edit SYSPRO Customer</span>
                      </button>
                    </mat-menu> -->
              </div>
            </div>
          </mat-card-subtitle>
          <div>
            <table>
              <tr>
                <th class="th-label">Invoice</th>
                <td class="td-value">{{invoice.invoiceNumber}}</td>
              </tr>
              <tr>
                <th class="th-label">Sales Order</th>
                <td class="td-value"><a
                    [routerLink]="['/pos/orders/syspro/' + invoice.salesOrderNumber]">{{invoice.salesOrderNumber}}</a>
                </td>
              </tr>
              <tr>
                <th class="th-label">Store</th>
                <td class="td-value">{{invoice.storeName}}</td>
              </tr>
              <tr>
                <th class="th-label">Salesperson</th>
                <td class="td-value">{{invoice.salesperson}}</td>
              </tr>
              <tr>
                <th class="th-label">Customer</th>
                <td class="td-value">{{invoice.customerCode}}</td>
              </tr>
              <tr>
                <th class="th-label">Currency</th>
                <td class="td-value">{{invoice.currencyName}}</td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <!-- <div class="card-footer-container">
                  <button mat-raised-button color="primary" (click)="editHeaderDetails()">Edit</button>
                </div> -->
        </mat-card-footer>
      </mat-card>

      <!-- Order Customer Details -->
      <mat-card fxFlex="50%" style="align-self: stretch;margin: 0px 8px 0px 8px;">
        <mat-card-content>
          <div style="width: 100%;" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">

            <div fxFlex="50%">
              <mat-card-subtitle>
                <div class="card-title-container">
                  <div>Customer Details</div>
                </div>
                <div *ngIf="invoice.canViewTfgAccount">
                  <img class="tfg-logo" src="/assets/images/tfg_small.jpg">
                </div>
              </mat-card-subtitle>
              <div>
                <table>

                  <tr>
                    <th class="th-label" style="min-width: 90px;">Name</th>
                    <td class="td-value">{{invoice.customerName}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Tax Number</th>
                    <td class="td-value">{{invoice.companyTaxNumber}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Telephone</th>
                    <td class="td-value">{{invoice.telephone}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Add. Tel.</th>
                    <td class="td-value">{{invoice.addTelephone}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Email</th>
                    <td class="td-value">{{invoice.email}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">On Hold</th>
                    <td class="td-value">{{invoice.customerOnHold}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Account Bal.</th>
                    <td class="td-value">{{invoice.customerAccountBalance | number:'1.0-0'}}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div fxFlex="50%">
              <mat-card-subtitle>
                <div class="card-title-container">
                  <div>Delivery Address</div>
                  <div>
                    <!-- <button
                      *ngIf="invoice.canEditSalesOrderCustomer || invoice.canAddTfgAccount || invoice.canViewTfgAccount"
                      mat-icon-button [matMenuTriggerFor]="menuCustomer" aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuCustomer="matMenu">
                      <button *ngIf="invoice.canEditSalesOrderCustomer" mat-menu-item
                        (click)="editCustomerDetails()">
                        <mat-icon>edit</mat-icon>
                        <span>Edit Customer Details</span>
                      </button>
                      <button *ngIf="invoice.canEditSalesOrderCustomer" mat-menu-item
                        (click)="refreshCustomerDetailsFromSyspro()">
                        <mat-icon>sync</mat-icon>
                        <span>Refresh from SYSPRO</span>
                      </button>
                      <button *ngIf="invoice.canAddTfgAccount" mat-menu-item (click)="linkTfgAccount()">
                        <mat-icon>person_add</mat-icon>
                        <span>Link TFG Account</span>
                      </button>
                      <button *ngIf="invoice.canViewTfgAccount" mat-menu-item (click)="viewTfgAccount()">
                        <mat-icon>person_search</mat-icon>
                        <span>View TFG Account</span>
                      </button>
                    </mat-menu> -->
                  </div>
                </div>
              </mat-card-subtitle>
              <div>
                <table>

                  <tr>
                    <th class="th-label" style="min-width: 90px;">Building</th>
                    <td class="td-value">{{invoice.shipToAddr1}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Str/Unit Nr</th>
                    <td class="td-value">{{invoice.shipToAddr2}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Street Name</th>
                    <td class="td-value">{{invoice.shipToAddr3}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Suburb / City</th>
                    <td class="td-value">{{invoice.shipToAddr4}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Province</th>
                    <td class="td-value">{{invoice.shipToAddr5}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Postal Code</th>
                    <td class="td-value">{{invoice.shipPostalCode}}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Lat / Long</th>
                    <td class="td-value">{{invoice.shipToGpsLat}} / {{invoice.shipToGpsLong}}</td>
                  </tr>
                </table>
              </div>
            </div>


          </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
      </mat-card>

      <!-- Financial Overview -->
      <mat-card fxFlex="25%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Financial Overview / Dates</div>
              <!-- <div>
                    <button mat-icon-button [matMenuTriggerFor]="menuFinancial" aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuFinancial="matMenu">
                     <button mat-menu-item (click)="editSalesPersonDetails()">
                        <mat-icon>support_agent</mat-icon>
                        <span>Change Salesperson</span>
                      </button>
                      <button (click)="useCashCustomer()" mat-menu-item>
                        <mat-icon>attach_money</mat-icon>
                        <span>Use Cash Customer</span>
                      </button>
                      <button (click)="searchCustomer()" mat-menu-item>
                        <mat-icon>search</mat-icon>
                        <span>Search Existing Customer</span>
                      </button>
                      <button (click)="createCustomer()" mat-menu-item>
                        <mat-icon>person_add</mat-icon>
                        <span>Create New Customer</span>
                      </button>
                    </mat-menu>
                  </div> -->
            </div>
          </mat-card-subtitle>
          <div>
            <table style="width: 100%;">
              <tr>
                <th class="th-label">Invoice Amount</th>
                <td class="td-value" style="text-align: right;">{{invoice.invoiceAmount | number:'1.2-2'}}</td>
              </tr>
              <tr>
                <th class="th-label">Invoice Balance</th>
                <td [ngClass]="{ 'os-warning-text': invoice.invoiceBalance !== 0 }" class="td-value"
                  style="text-align: right;">{{invoice.invoiceBalance | number:'1.2-2'}}</td>
              </tr>
              <tr>
                <th class="th-label">Pending EFT Req.</th>
                <td class="td-value" style="text-align: right;">{{invoice.pendingEftRequests | number:'1.2-2'}}</td>
              </tr>
              <tr>
                <th class="th-label">Act. Invoice Balance</th>
                <td [ngClass]="{ 'os-warning-text': invoice.actualInvoiceBalance !== 0 }" class="td-value"
                  style="text-align: right;">{{invoice.actualInvoiceBalance | number:'1.2-2'}}</td>
              </tr>
              <tr>
                <th class="th-label">Deposit Balance</th>
                <td class="td-value" style="text-align: right;">{{invoice.depositBalance | number:'1.2-2'}}
                </td>
              </tr>
              <tr>
                <th class="th-label">Invoice Created</th>
                <td class="td-value" style="text-align: right;">{{invoice.invoiceCreatedDate | date:'mediumDate'}}
                </td>
              </tr>
              <tr>
                <th class="th-label">Order Created</th>
                <td class="td-value" style="text-align: right;">{{invoice.orderCreatedDate | date:'mediumDate'}}
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <!-- <div class="card-footer-container">
                  <button mat-raised-button color="primary" (click)="editHeaderDetails()">Edit</button>
                </div> -->
        </mat-card-footer>
      </mat-card>
    </div>

    <!-- Lines Row -->
    <div style="width: 100%; margin: 8px 0px 0px 0px;">
      <mat-card>
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Line Details</div>
              <div>
                <button mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div style="width: 100%">
            <kendo-grid [kendoGridBinding]="invoice.lines" [scrollable]="true" [resizable]="true" [reorderable]="true"
              [sortable]="true">

              <!-- <kendo-grid-column [locked]="true" [width]="30" title="" class="td-action">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button
                *ngIf="dataItem.comments|| dataItem.canEditLine || dataItem.canAddCoriguard || dataItem.canRemoveCoriguard || dataItem.canDeleteDeliveryFee || dataItem.canModifyDiscount"
                mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #rowMenu="matMenu">
                <button *ngIf="dataItem.canEditLine" mat-menu-item (click)="editLine(dataItem)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit Warehouse / Qty</span>
                </button>
                <button *ngIf="dataItem.canModifyDiscount" mat-menu-item (click)="modifyLineDiscount(dataItem)">
                  <mat-icon>sell</mat-icon>
                  <span>Edit Price / Discount</span>
                </button>
                <button *ngIf="dataItem.canEditLine" mat-menu-item (click)="deleteLine(dataItem)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete Line</span>
                </button>
                <button *ngIf="dataItem.canEditLine" mat-menu-item (click)="copyLine(dataItem)">
                  <mat-icon>content_copy</mat-icon>
                  <span>Copy Line</span>
                </button>
                <button *ngIf="dataItem.canAddCoriguard" mat-menu-item (click)="addCoriguard(dataItem)">
                  <mat-icon>add_moderator</mat-icon>
                  <span>Add Coriguard</span>
                </button>
                <button *ngIf="dataItem.canRemoveCoriguard" mat-menu-item (click)="removeCoriguard(dataItem)">
                  <mat-icon>remove_moderator</mat-icon>
                  <span>Remove Coriguard</span>
                </button>
                <button *ngIf="dataItem.canDeleteDeliveryFee" mat-menu-item (click)="deleteDeliveryFee(dataItem)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete Line</span>
                </button>
                <button *ngIf="dataItem.comments" mat-menu-item (click)="showComments(dataItem.comments)">
                  <mat-icon>comments</mat-icon>
                  <span>Show Comments</span>
                </button>
              </mat-menu>
            </ng-template>
          </kendo-grid-column> -->

              <!-- <kendo-grid-column [locked]="true" [width]="75" title="" class="td-action">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div style="display: flex;flex-direction: row;align-content: center;">
                <mat-icon *ngIf="dataItem.canAddCoriguard">shield</mat-icon>
                <mat-icon *ngIf="dataItem.canRemoveCoriguard">verified_user</mat-icon>
                <mat-icon *ngIf="dataItem.isCoriguard">local_police</mat-icon>
                <mat-icon *ngIf="dataItem.lineType === '5'">local_shipping</mat-icon>
                <mat-icon *ngIf="dataItem.lineDepositRequired > 0">attach_money</mat-icon>
                <mat-icon *ngIf="dataItem.discountReasonCode">sell</mat-icon>
                <mat-icon *ngIf="mode === 'SYSPRO' && dataItem.invoiced">done_all</mat-icon>
                <mat-icon *ngIf="mode === 'SYSPRO' && !dataItem.invoiced && dataItem.invoicedQty > 0">done
                </mat-icon>
                <mat-icon *ngIf="dataItem.comments">comment</mat-icon>
              </div>
            </ng-template>
          </kendo-grid-column> -->

              <kendo-grid-column [locked]="true" [width]="140" field="displayCode" title="Code">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <ng-container *ngIf="dataItem.lineType === '1' && dataItem.isCoriguard === false; else textCode">
                    <a [routerLink]="'/generic/detail-page/stock-code-details/' + dataItem.displayCode">
                      {{ dataItem.displayCode }}
                    </a>
                  </ng-container>
                  <ng-template #textCode>
                    {{ dataItem.displayCode }}
                  </ng-template>
                </ng-template>
                <!-- <ng-template kendoGridFooterTemplate>
                  Order Totals
                </ng-template> -->
              </kendo-grid-column>

              <kendo-grid-column [locked]="true" [width]="550" title="Description">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="ellipse">{{dataItem.lineDescription2 ? dataItem.lineDescription + ' - ' +
                    dataItem.lineDescription2 :dataItem.lineDescription}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="100" field="warehouseCode" title="Warehouse"> </kendo-grid-column>

              <kendo-grid-column [hidden]="compactView === true" [width]="250" title="Warehouse Desc">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span class="ellipse">{{dataItem.warehouseDesc}}</span>
                </ng-template>
              </kendo-grid-column>



              <kendo-grid-column [width]="100" field="invoicedQty" format="{0:n0}" class="td-number" title="Inv. Qty">
              </kendo-grid-column>

              <kendo-grid-column [width]="100" field="creditedQty" format="{0:n0}" class="td-number" title="CR. Qty">
              </kendo-grid-column>

              <kendo-grid-column [width]="100" field="allowedToReturnQty" format="{0:n0}" class="td-number"
                title="Av. Qty">
              </kendo-grid-column>

              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="unitRspIncludingVat"
                title="RSP Incl."> </kendo-grid-column>

              <kendo-grid-column [hidden]="compactView === true" [width]="100" format="{0:n2}" class="td-number"
                field="discountPercentage" title="Disc. Perc."> </kendo-grid-column>

              <kendo-grid-column [hidden]="compactView === true" [width]="130" format="{0:n2}" class="td-number"
                field="discountValue" title="Disc. Amt."> </kendo-grid-column>

              <kendo-grid-column [hidden]="compactView === true" [width]="100" field="discountValueFlag"
                title="Disc. Flag"> </kendo-grid-column>

              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineDiscountAmount"
                title="Line Disc.">
                <!-- <ng-template kendoGridFooterTemplate>
                  <div class="td-number">{{invoice.discountAmount | number:'1.2-2'}}</div>
                </ng-template> -->
              </kendo-grid-column>

              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineTotalAmount"
                title="Line Amt.">
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">{{invoice.totalAmount | number:'1.2-2'}}</div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [hidden]="compactView === true" [width]="130" format="{0:n2}" class="td-number"
                field="lineVatAmount" title="Line Vat">
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">{{invoice.vatAmount | number:'1.2-2'}}</div>
                </ng-template>
              </kendo-grid-column>

            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <div class="card-footer-container">
            <div style="display: flex;justify-content: space-between;align-content: center;">
              <div>
                <button *ngIf="invoice.canCreateCreditOrder" mat-button color="primary"
                  (click)="createCreditNote()">Create Credit Note</button>
                <!--
            <button *ngIf="invoice.orderType === 'DRAFT'" mat-button color="primary" (click)="test()">Search
              Items</button>
            <button *ngIf="invoice.canAddDeliveryFee" mat-button color="primary" (click)="addDeliverFee()">Add
              Delivery Fee</button>
            <button *ngIf="invoice.canInvoiceLines" mat-button color="primary" (click)="invoiceLines()">Invoice
              Lines</button>
            <button *ngIf="invoice.comments" mat-button color="primary"
              (click)="showComments(invoice.comments)">Show Order Comments</button>-->
              </div>
              <div style="margin-right: 16px;">
                <mat-slide-toggle [color]="primary" [(ngModel)]="compactView">Compact View</mat-slide-toggle>
              </div>
            </div>
          </div>
        </mat-card-footer>
      </mat-card>
    </div>

    <!-- Credit Notes Row -->
    <div style="width: 100%; margin: 8px 0px 0px 0px;">
      <mat-card>
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Credit Notes</div>
              <div>
                <button mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div style="width: 100%">
            <kendo-grid [kendoGridBinding]="invoice.creditNotes" [scrollable]="true" [resizable]="true"
              [reorderable]="true" [sortable]="true">

              <kendo-grid-column [width]="50" title="" class="td-action">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <button matTooltip="Generate Credit Note Document" *ngIf="dataItem.canCreateCreditNote"
                    mat-icon-button (click)="generateCreditNoteDocument(dataItem)">
                    <mat-icon>post_add</mat-icon>
                  </button>
                  <button matTooltip="Download Credit Note Document" *ngIf="dataItem.canDownloadCreditNote"
                    mat-icon-button (click)="downloadResource(dataItem.resource)">
                    <mat-icon>download</mat-icon>
                  </button>
                  <button matTooltip="Email Credit Note Document" *ngIf="dataItem.canDownloadCreditNote" mat-icon-button
                    (click)="emailDocument(dataItem.email)">
                    <mat-icon>forward_to_inbox</mat-icon>
                  </button>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="130" field="entrySystemDate" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.entrySystemDate | date: 'MMM d, yyyy'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="120" field="creditSalesOrderNumber" title="Credit Note">
              </kendo-grid-column>

              <kendo-grid-column [width]="120" field="creditInvoiceNumber" title="Credit Invoice">
              </kendo-grid-column>

              <kendo-grid-column [width]="120" field="salesOrderNumber" title="Sales Order">
              </kendo-grid-column>

              <kendo-grid-column [width]="70" field="orderStatus" title="Status">
              </kendo-grid-column>

              <kendo-grid-column [width]="70" field="cancelledFlag" title="Cancelled">
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="branch" title="Branch">
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="createdBy" title="Created By">
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="salesperson" title="Salesperson">
              </kendo-grid-column>

              <ng-template kendoGridDetailTemplate let-dataItem>
                <kendo-grid [kendoGridBinding]="dataItem.lines" [scrollable]="true" [resizable]="true"
                  [reorderable]="true" [sortable]="true">

                  <kendo-grid-column [locked]="true" [width]="140" field="displayCode" title="Code">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                      <ng-container *ngIf="dataItem.lineType === '1' && dataItem.isCoriguard === false; else textCode">
                        <a [routerLink]="'/generic/detail-page/stock-code-details/' + dataItem.displayCode">
                          {{ dataItem.displayCode }}
                        </a>
                      </ng-container>
                      <ng-template #textCode>
                        {{ dataItem.displayCode }}
                      </ng-template>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column [locked]="true" [width]="550" title="Description">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                      <span class="ellipse">{{dataItem.lineDescription2 ? dataItem.lineDescription + ' - ' +
                        dataItem.lineDescription2 :dataItem.lineDescription}}</span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column [width]="100" field="warehouseCode" title="Warehouse">
                  </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="250" title="Warehouse Desc">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                      <span class="ellipse">{{dataItem.warehouseDesc}}</span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="250" title="Reason">
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                      <span class="ellipse">{{dataItem.creditReason}}</span>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column [width]="100" field="orderQty" format="{0:n0}" class="td-number" title="Order Qty">
                  </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="100" field="shipQty" format="{0:n0}"
                    class="td-number" title="Ship Qty">
                  </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="100" field="backOrderQty" format="{0:n0}"
                    class="td-number" title="BO Qty">
                  </kendo-grid-column>

                  <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="unitRspIncludingVat"
                    title="RSP Incl."> </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="100" format="{0:n2}" class="td-number"
                    field="discountPercentage" title="Disc. Perc."> </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="130" format="{0:n2}" class="td-number"
                    field="discountValue" title="Disc. Amt."> </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="100" field="discountValueFlag"
                    title="Disc. Flag"> </kendo-grid-column>

                  <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineDiscountAmount"
                    title="Line Disc.">
                  </kendo-grid-column>

                  <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="lineTotalAmount"
                    title="Line Amt.">
                    <ng-template kendoGridFooterTemplate>
                      <div class="td-number">{{invoice.totalAmount | number:'1.2-2'}}</div>
                    </ng-template>
                  </kendo-grid-column>

                  <kendo-grid-column [hidden]="compactView === true" [width]="130" format="{0:n2}" class="td-number"
                    field="lineVatAmount" title="Line Vat">
                    <ng-template kendoGridFooterTemplate>
                      <div class="td-number">{{invoice.vatAmount | number:'1.2-2'}}</div>
                    </ng-template>
                  </kendo-grid-column>

                </kendo-grid>
              </ng-template>
            </kendo-grid>
          </div>
        </mat-card-content>
        <!-- <mat-card-footer>
          <div class="card-footer-container">
            <div style="display: flex;justify-content: space-between;align-content: center;">
              <div>
                <button *ngIf="invoice.orderType === 'DRAFT'" mat-button color="primary" (click)="scan()">Scan
                  Items</button>
                <button *ngIf="invoice.orderType === 'DRAFT'" mat-button color="primary" (click)="test()">Search
                  Items</button>
                <button *ngIf="invoice.canAddDeliveryFee" mat-button color="primary" (click)="addDeliverFee()">Add
                  Delivery Fee</button>
                <button *ngIf="invoice.canInvoiceLines" mat-button color="primary" (click)="invoiceLines()">Invoice
                  Lines</button>
                <button *ngIf="invoice.comments" mat-button color="primary"
                  (click)="showComments(invoice.comments)">Show Order Comments</button>
              </div>
              <div style="margin-right: 16px;">
                <mat-slide-toggle [color]="primary" [(ngModel)]="compactView">Compact View</mat-slide-toggle>
              </div>
            </div>
          </div>
        </mat-card-footer> -->
      </mat-card>
    </div>

    <!-- Payments / Credit Notes -->
    <div style="width: 100%;margin-top: 8px;margin-bottom: 8px;" fxLayout="row" fxLayoutAlign="start start"
      fxLayoutGap="8px">

      <!-- Deoposits -->
      <mat-card fxFlex="50%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Deposits Transactions</div>
              <div>
                <button [matTooltip]="'Refresh Details'" mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div style="width: 100%">
            <kendo-grid [kendoGridBinding]="invoice.deposits" [scrollable]="true" [resizable]="true"
              [reorderable]="true" [sortable]="true">

              <kendo-grid-column [width]="130" field="transactionDate" title="Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.transactionDate | date: 'MMM d, yyyy'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="130" field="transactionType" title="Type">
                <ng-template kendoGridFooterTemplate>
                  <div>Balance</div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="transactionAmount"
                title="Amount">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="td-number">{{dataItem.transactionAmount | number:'1.2-2'}}</div>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">{{invoice.depositBalance | number:'1.2-2'}}</div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="200" field="containerDesc" title="Method"> </kendo-grid-column>
              <kendo-grid-column [width]="250" field="storeName" title="Store"> </kendo-grid-column>
              <kendo-grid-column [width]="250" field="userName" title="User"> </kendo-grid-column>
              <kendo-grid-column [width]="250" field="refundReason" title="Refund Reason"> </kendo-grid-column>
            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
      </mat-card>


      <mat-card fxFlex="50%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Payments</div>
              <div>
                <!-- <button matTooltip="Generate Payment Receipts Document" *ngIf="salesOrder?.canCreatePayments"
                  mat-icon-button (click)="generateReceiptDocument(salesOrder.createPaymentsPayload)">
                  <mat-icon>post_add</mat-icon>
                </button>
                <button matTooltip="Download Payment Receipts Document" *ngIf="salesOrder?.canDownloadPayments"
                  mat-icon-button (click)="downloadResource(salesOrder.paymentsResource)">
                  <mat-icon>download</mat-icon>
                </button>
                <button matTooltip="Email Payment Receipts Document" *ngIf="salesOrder?.canDownloadPayments"
                  mat-icon-button (click)="emailDocument(salesOrder.paymentEmail)">
                  <mat-icon>forward_to_inbox</mat-icon>
                </button> -->
                <button [matTooltip]="'Refresh Details'" mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div>
            <kendo-grid [kendoGridBinding]="invoice.payments" [scrollable]="true" [resizable]="true"
              [reorderable]="true" [sortable]="true">

              <kendo-grid-column [width]="130" field="paymentType" title="Type"> </kendo-grid-column>
              <kendo-grid-column [width]="130" field="invoiceNumber" title="Invoice"> </kendo-grid-column>
              <kendo-grid-column [width]="180" field="containerDesc" title="Method"> </kendo-grid-column>
              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="amountPaid" title="Amount">
              </kendo-grid-column>
              <kendo-grid-column [width]="150" field="creationDate" title="Paid At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.creationDate | date: 'MMM d, yyyy'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="70" field="paymentVoided" title="Voided">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.paymentVoided ? 'Yes' : 'No'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="70" field="isProvisional" title="Paid At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.isProvisional ? 'Yes' : 'No'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="200" field="userDisplayName" title="Capture By"> </kendo-grid-column>
              <kendo-grid-column [width]="250" field="refundReason" title="Refund Reason"> </kendo-grid-column>
            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
      </mat-card>
    </div>

    <!-- Emails / EFT Refund Requests -->
    <div style="width: 100%;margin-top: 8px;margin-bottom: 8px;" fxLayout="row" fxLayoutAlign="start start"
      fxLayoutGap="8px">

      <mat-card fxFlex="50%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Emails</div>
              <div>
                <button [matTooltip]="'Refresh Details'" mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div>
            <kendo-grid [kendoGridBinding]="invoice.emails" [scrollable]="true" [resizable]="true" [reorderable]="true"
              [sortable]="true">

              <kendo-grid-column [width]="150" field="emailType" title="Email. Type"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.sentAt | date: 'MMM d, yyyy HH:mm'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="250" field="sentTo" title="Sent To"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="stepStatus" title="Step Status"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="emailStatus" title="Email Status"> </kendo-grid-column>


            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
      </mat-card>

      <mat-card fxFlex="50%" style="align-self: stretch;">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Refund Requests</div>
              <div>
                <button [matTooltip]="'Refresh Details'" mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div>
            <kendo-grid [kendoGridBinding]="invoice.eftRequests" [scrollable]="true" [resizable]="true"
              [reorderable]="true" [sortable]="true">

              <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="requestedAmount" title="Amount">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="td-number">{{dataItem.requestedAmount | number:'1.2-2'}}</div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="120" field="requestStatus" title="Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.requestStatus}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="100" field="requestedBranch" title="Requested Branch">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.requestedBranch}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="requestedAt" title="Requested At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.requestedAt | date: 'MMM d, yyyy HH:mm'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="requestedBy" title="Requested By">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.requestedBy}}</span>
                </ng-template>
              </kendo-grid-column>

               <kendo-grid-column [width]="200" field="refundReason" title="Refund Reason">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.refundReason}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="requestedComment" title="Request Comment">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.requestedComment}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="actionedAt" title="Actioned At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.actionedAt | date: 'MMM d, yyyy HH:mm'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="actionedBy" title="Actioned By">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.actionedBy}}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column [width]="200" field="actionedComment" title="Action Comment">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="ellipse">{{dataItem.actionedComment}}</span>
                </ng-template>
              </kendo-grid-column>




            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
      </mat-card>


    </div>
  </div>

</ng-container>

<ng-template #loadingTemplate>
  <mat-card>
    <mat-card-content>
      <div style="display: flex;align-items: center;justify-content: center;align-content: center;margin: 32px;">
        Fetching invoice details, please wait....
      </div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </mat-card-content>
  </mat-card>
</ng-template>
